import { MutationTree, ActionTree } from "vuex"

import utils from "~/mixins/global"

import { RootState } from "~/store"

const defaultConfiguration = function () {
  return {
    id: "0",
    duration: 8000,
    timeoutId: null as null | number,
    class: {} as Record<string, boolean> | string | string[],
    props: {} as Record<string, any>,
    component: null as null | any, //Vue component required
    callbacks: {
      use: function () {} as () => void,
      close: function () {} as () => void,
      timeout: function () {} as () => void,
    },
    hooks: {
      beforeCreate: function () {} as () => void,
      mounted: function () {} as () => void,
      beforeDestroy: function () {} as () => void,
      destroy: function () {} as () => void,
    },
  }
}

export const state = () => ({
  queue: [] as SnackbarConfiguration[],
})
export type SnackbarState = ReturnType<typeof state>
export type SnackbarConfiguration = ReturnType<typeof defaultConfiguration>
export type SnackbarRemovalMethods = "BY_ID"

export const mutations: MutationTree<SnackbarState> = {
  PUSH: function (state, config: SnackbarConfiguration) {
    state.queue.push(config)
  },
  REMOVE_TIMEOUT_ID: function (state, id: string) {
    const index = state.queue.findIndex((config) => config.id === id)

    if (index >= 0) {
      const timeoutId = state.queue[index].timeoutId

      if (typeof state.queue[index].callbacks.timeout === "function")
        state.queue[index].callbacks.timeout()

      if (timeoutId) window.clearTimeout(timeoutId)
      state.queue[index].timeoutId = null
    }
  },
  REMOVE_BY_ID: function (state, id: string) {
    const index = state.queue.findIndex((config) => config.id === id)

    if (index >= 0) state.queue.splice(index, 1)
  },
}

export const actions: ActionTree<SnackbarState, RootState> = {
  CREATE: function ({ commit, dispatch }, payload: SnackbarConfiguration) {
    const config = defaultConfiguration()
    let key: keyof SnackbarConfiguration

    for (key in config) {
      // TODO Store - Find a better way !
      //@ts-ignore
      if (typeof config[key] === typeof payload[key]) config[key] = payload[key]
    }
    config.id = utils.methods.makeid()
    dispatch("TIMER", config).then((timeoutId: number) => {
      commit("PUSH", {
        ...config,
        timeoutId,
      })
    })
  },
  TIMER: function ({ dispatch }, config: SnackbarConfiguration) {
    const payload = {
      method: "BY_ID",
      id: config.id,
    }

    return window.setTimeout(() => {
      dispatch("REMOVE", payload)
    }, config.duration)
  },
  REMOVE: function (
    { commit, dispatch },
    { method, id }: { method: SnackbarRemovalMethods; id: string }
  ) {
    dispatch("REMOVE_TID", id).then(() => {
      commit("REMOVE_" + method, id)
    })
  },
  REMOVE_TID: function ({ commit }, id) {
    commit("REMOVE_TIMEOUT_ID", id)
  },
}
